import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: "sps-advanced-search",
    templateUrl: "./sps-advanced-search.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsAdvancedSearchComponent implements OnInit {
    static readonly displayName = "sps-advanced-search";
    static readonly props = {
        formGroup: "FormGroup",
        defaults: "T",
        submit: { event: true, type: "T" },
        clear: { event: true, type: "void" },
        controlsDisabled: "boolean",
        isOpen: "boolean",
    };

    @HostBinding("class.sps-advanced-search") readonly _spsAdvancedSearchClass = true;

    @Input() formGroup: FormGroup;
    @Input() defaults: any;
    @Output() submit = new EventEmitter<any>();
    @Output() clear = new EventEmitter<void>();

    @Input() controlsDisabled = false;

    @Input()
    @HostBinding("class.sps-advanced-search--open")
    isOpen = false;

    @HostBinding("class.sps-advanced-search--pinned")
    @HostBinding("class.z-stratum-bar")
    isPinned = false;

    enteredFieldsCount = new BehaviorSubject(0);

    ngOnInit() {
        this.emitFieldChangedCount();
        this.formGroup.valueChanges
            .subscribe(() => {
                this.emitFieldChangedCount();
            });
    }

    emitFieldChangedCount() {
        if (this.formGroup) {
            const baseline = this.defaults || {};
            const value = this.formGroup.value;
            const count = Object.keys(value)
                .filter(k => value[k] !== baseline[k])
                .length;
            this.enteredFieldsCount.next(count);
        }
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    pin() {
        this.isPinned = true;
    }

    unpin() {
        this.isPinned = false;
    }

    onSubmit(event) {
        event.stopPropagation();
        this.submit.emit(this.formGroup ? this.formGroup.value : undefined);
    }

    onClear() {
        if (this.formGroup) {
            if (this.defaults) {
                this.formGroup.setValue(this.defaults);
            } else {
                this.formGroup.reset();
            }
        }
        this.clear.emit();
    }
}
